import React from 'react';
import Modal from 'react-modal';
import _isEmpty from 'lodash/isEmpty';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import Theme from '../ui/Theme';
import RulesDisplay from '../rules/RulesDisplay';

const useStyles = makeStyles(() => ({
  popupHeading: {
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
    paddingLeft: '18px',
  },
}));
const RuleConditionsPopup = ({ rule, close }) => {
  const classes = useStyles();

  return (
    <Modal
      isOpen
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
        },
        content: {
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          border: 0,
          height: !_isEmpty(rule?.conditions) ? '450px' : '100px',
          width: '930px',
          overflow: 'auto',
          borderRadius: '8px',
        },
        popupCloseBtn: {
          borderRadius: '50%',
          backgroundColor: Theme.palette.secondary.main,
          padding: '8px',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
          },
          cursor: 'pointer',
        },
      }}
    >
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={11}>
          <p className={classes.popupHeading}>{rule?.name} Rule</p>
        </Grid>
        <Grid item xs={1} style={{ cursor: 'pointer' }}>
          <CloseIcon className={classes.popupCloseBtn} onClick={close} />
        </Grid>
      </Grid>
      <RulesDisplay ruleDetails={rule} />
    </Modal>
  );
};

export default RuleConditionsPopup;
